import $ from 'jquery'
import SFetch from '@app/utils/sfetch'

// Helper function to collect current form values for getTemplateUsagePreview
const collectFormValues = (form) => {
  const $form = $(form)

  const defaultWorkflowId = $form
    .find('select#company_template_default_firm_workflow_id')
    .val()

  const additionalWorkflowIds = $form
    .find('div[data-behaviour=company-template-firm-workflows-list] select')
    .map(function () {
      return $(this).val()
    })
    .get()
    .filter((id) => id && id !== '')

  const permanentTextIds = $form
    .find('div[data-behaviour=company-presets-permanent-entries-list] select')
    .map(function () {
      return $(this).val()
    })
    .get()
    .filter((id) => id && id !== '')

  const reportTemplateIds = $form
    .find('div[data-behaviour=company-presets-report-templates-list] select')
    .map(function () {
      return $(this).val()
    })
    .get()
    .filter((id) => id && id !== '')

  const accountMappingListId = $form
    .find('select#company_template_account_mapping_list_id')
    .val()

  const templateId = $form.data('template-id')

  return {
    templateId,
    defaultWorkflowId,
    additionalWorkflowIds,
    permanentTextIds,
    reportTemplateIds,
    accountMappingListId,
  }
}

// Function to trigger template usage preview update with current form values
const triggerTemplateUsagePreview = (form, url) => {
  const formValues = collectFormValues(form)
  return getTemplateUsagePreview(url, formValues)
}
const disableIneligibleWorkflows = (form) => {
  const $form = $(form)
  const accountMappingInput = $form.find(
    'div.company_template_account_mapping_list'
  )
  const defaultWorkflowSelect = $form.find(
    'select#company_template_default_firm_workflow_id'
  )
  const additionalWorkflowSelect = $form.find(
    'div[data-behaviour=company-template-firm-workflows-list] select'
  )

  const defaultWorkflowId = defaultWorkflowSelect.val()
  const personalWorkflowIds = $form
    .data('personal-workflow-ids')
    .map((e) => e.toString())
  const corporateWorkflowIds = defaultWorkflowSelect
    .children('option')
    .toArray()
    .map((e) => e.value)
    .filter((e) => !personalWorkflowIds.includes(e) && e !== '')
  const hasPersonalCompanies = $form.data('has-personal-companies')
  const hasCorporateCompanies = $form.data('has-corporate-companies')

  const enableOptions = (selectElement, optionIds) => {
    for (const id of optionIds) {
      selectElement.children(`option[value='${id}']`).attr('disabled', false)
    }
  }

  const disableOptions = (selectElement, optionIds) => {
    for (const id of optionIds) {
      selectElement
        .children(`option[value='${id}']`)
        .attr('disabled', true)
        .prop('selected', false)
    }
  }

  if (hasPersonalCompanies) {
    disableOptions(defaultWorkflowSelect, corporateWorkflowIds)
  } else if (hasCorporateCompanies) {
    disableOptions(defaultWorkflowSelect, personalWorkflowIds)
  }

  if (personalWorkflowIds.includes(defaultWorkflowId)) {
    accountMappingInput.hide()

    enableOptions(additionalWorkflowSelect, personalWorkflowIds)
    disableOptions(additionalWorkflowSelect, corporateWorkflowIds)
  } else {
    accountMappingInput.show()

    enableOptions(additionalWorkflowSelect, corporateWorkflowIds)
    disableOptions(additionalWorkflowSelect, personalWorkflowIds)
  }

  // Disable selecting the Default Workflow in Additional Workflows
  disableOptions(additionalWorkflowSelect, [defaultWorkflowId])
}

const getTemplateUsagePreview = (url, params = {}) => {
  const {
    defaultWorkflowId,
    additionalWorkflowIds = [],
    permanentTextIds = [],
    reportTemplateIds = [],
    accountMappingListId,
  } = params

  let queryParams = `default_workflow_id=${defaultWorkflowId || ''}`

  if (additionalWorkflowIds.length > 0) {
    queryParams += `&additional_workflow_ids=${additionalWorkflowIds.join(',')}`
  }

  if (permanentTextIds.length > 0) {
    queryParams += `&permanent_text_ids=${permanentTextIds.join(',')}`
  }

  if (reportTemplateIds.length > 0) {
    queryParams += `&report_template_ids=${reportTemplateIds.join(',')}`
  }

  if (accountMappingListId) {
    queryParams += `&account_mapping_list_id=${accountMappingListId}`
  }

  url = url + `?${queryParams}`

  return SFetch.json(url, {
    method: 'GET',
  }).then((response) => {
    return response
  })
}

let observer = null

onDomLoad(() => {
  if (observer) {
    observer.disconnect()
  }

  document
    .querySelectorAll("[data-behaviour='client-type-form']")
    .forEach((form) => {
      disableIneligibleWorkflows(form)

      observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          const target = mutation.target
          if (
            target.closest(
              '[data-behaviour="company-template-firm-workflows-list"]'
            )
          ) {
            disableIneligibleWorkflows(form)
          }
        })
      })

      const workflowsList = form.querySelector(
        '[data-behaviour="company-template-firm-workflows-list"]'
      )
      if (workflowsList) {
        observer.observe(workflowsList, {
          childList: true,
          subtree: true,
        })
      }

      form
        .querySelector('#company_template_default_firm_workflow_id')
        ?.addEventListener('change', () => {
          disableIneligibleWorkflows(form)
        })
    })
})

document.addEventListener('turbolinks:before-visit', () => {
  if (observer) {
    observer.disconnect()
    observer = null
  }
})

// Expose functions globally for use in other modules
window.getTemplateUsagePreview = getTemplateUsagePreview
window.collectFormValues = collectFormValues
window.triggerTemplateUsagePreview = triggerTemplateUsagePreview
